<div class="sub-title-copy text-center margin-bottom mb16">
  {{ 'SERVICE_NOT_AVAILABLE' | translate }}
</div>
<div class="row">
  <mapfre-info-divs> 
      {{ 'BOP_POLICIES_CANNOT_BE_ACCESS_VIA_CUSTOMER_PORTAL' | translate }}
  </mapfre-info-divs>
</div>
<hr class="margin-vertical mv24">

